import { ApplicationError } from "@rocicorp/zero";

export type UserFacingMessageParts = readonly (
  | string
  | { permission: string }
)[];

/**
 * Mutation or validation failure safe to show in a toast (see
 * `classifyZeroResult` in `services/ui/lib/zeroResultError.ts`).
 */
export function userFacingError(
  message: string | UserFacingMessageParts,
  extra?: Record<string, unknown>
): ApplicationError {
  const messageParts = typeof message === "string" ? undefined : message;
  return new ApplicationError(
    typeof message === "string"
      ? message
      : message
          .map((part) => (typeof part === "string" ? part : part.permission))
          .join(""),
    {
      details: {
        userFacing: true,
        ...extra,
        ...(messageParts && { messageParts }),
      },
    }
  );
}

export function isUserFacingError(error: unknown): boolean {
  return (
    error != null &&
    typeof error === "object" &&
    "details" in error &&
    (error as { details?: { userFacing?: boolean } }).details?.userFacing ===
      true
  );
}
